import React from 'react';
import agent from '../agent';
const Promise = global.Promise;
const LOADING = 'Uploading...';

class Upload extends React.Component {
  constructor() {
    super();

    this.state = {
      directUrl: '',
      files: [
        {
          fileBody: null, 
          url: ''
        }
      ],
    }

    this.urlChange = event => {
      const state = this.state;
      const directUrl = event.target.value;
      const newState = Object.assign({}, {directUrl});
      console.log('updating state', newState);
      this.setState(newState);
    }
    
    this.useUrl = () => {
      this.props.afterUpload(this.state.directUrl);
    }

    this.onChangeHandler = event => {
      let files = this.state.files.map((file, i) => {
        if(i == event.target.dataset.count) {
          return {fileBody: event.target.files[0], url: event.target.files[0] ? URL.createObjectURL(event.target.files[0]) : ''}
        }else {
          return file;
        }
      })
      const newState = Object.assign({}, this.state, {files: files});
      this.setState(newState);
    }

    this.uploadFiles = () => {
      const data = new FormData();
      for (var i = 0; i < this.state.files.length; i++){
        if(this.state.files[i].fileBody) {
          data.append(i, this.state.files[i].fileBody);
        }
      }
      const req = new XMLHttpRequest();
      var that = this;
      req.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          console.log(JSON.parse(req.responseText));
          that.updateState(JSON.parse(req.responseText));
        }else if(this.readyState == 4 && this.status !== 200) {
          alert('Error occurred. Please try again');
        }
      };
      req.open("POST", "https://dearinvite.com/sites/files");
      req.send(data);
      this.updateState([]);
    }

    this.addFile = () => {
      const files = [...this.state.files, {fileBody: null, url: ''}]
      const newState = Object.assign({}, this.state, {files: files});
      this.setState(newState);
    }
    
    this.removeFile = event => {
      let files = [];
      this.state.files.map((file, i) => {
        if(i != event.target.dataset.count) {
          files.push(file);
        }
      });
      const newState = Object.assign({}, this.state, {files: files});
      this.setState(newState);
    }

    this.updateState = (results) => {
      const files = [];
      let resultObj = {};
      if(results) {
        results.map(result => {
          resultObj[result.attr] = '/files/'+result.newName;
        })
      }
      this.state.files.map((file, i) => {
        let updatedFile = Object.assign({}, file, {message: resultObj[i.toString()] ? resultObj[i.toString()] : LOADING});
        console.log(i, resultObj);
        if(i == 0 && resultObj[0]) {
          console.log(resultObj[0]);
          this.props.afterUpload(resultObj[0]);
        }
        files.push(updatedFile);
      });
      const newState = Object.assign({}, this.state, {files: files});
      this.setState(newState);
    };
  }

  render() {
    let fileObj = this.state.files[0];
    return (
      <div className="container">
        <input type="file" name="file" data-count={0} onChange={this.onChangeHandler}/>
        &nbsp;
        {fileObj.url && 
          <img style={{borderRadius : '100%', maxWidth: '200px', maxHeight: '200px'}} src={fileObj.url}/>
        }
        <br/>
        {fileObj.message === LOADING ? fileObj.message :  (fileObj.message  ? 'Uploaded. Please close. (' + fileObj.message+')' : '')}
        <br/>
        <div style={{textAlign: 'center'}}>
          <button type="button" className="btn btn-success" onClick={this.uploadFiles}>Upload</button> 
        </div>
        <br/><b>OR</b><br/><br/>
        <div className="form-group col-md-6">
          <label htmlFor="urlInput">Enter URL of the file</label>
          <input type="text" className="form-control" name="Name" 
            id="urlInput" 
            placeholder="Please enter /files/filename for dearinvite files"
            value={this.state.directUrl} 
            onChange={this.urlChange}></input>
          <div style={{marginTop: '10px'}}>
            <button type="button" className="btn btn-success" onClick={this.useUrl}>Use Direct Url</button> 
          </div>
        </div>
      </div>
    );
  }
}

export default Upload;
